module.exports = __webpack_public_path__ + "static/media/name.8e315814.svg";